export default {
  form: {
    name: 'Prénom*',
    surname: 'Nom*',
    email: 'E-mail*',
    company: 'Entreprise',
    agency: 'Agence*',
    phone: 'Téléphone',
    note: 'Remarques',
    fileUpload: 'CV au format PDF*',
    fileUploadTxt: 'Téléchargez votre CV (max 2,5 Mo)',
    fileUploadSizeError:
      'La taille du fichier est trop grande, veuillez sélectionner un fichier de maximum 2,5 Mo.',
    message: 'Description de la demande*',
    privacyCaption:
      'Conformément au Règlement UE 2016/679 - RGPD, je consens au traitement de mes données personnelles comme indiqué dans <a href="{ url }" target="_blank" rel="noreferrer" class="link-underline-1"><span>la politique de confidentialité</span></a>*',
    privacyError: 'Vous devez accepter notre politique de confidentialité.',
    newsletterCaption:
      "Je souhaite recevoir des mises à jour sur les nouveautés et événements Maley",
    submitCTA: 'ENVOYER LA DEMANDE',
    contattiCTA: 'Envoyer la demande',
    genericError: 'Champ mal rempli',
    successPageTitle: 'Votre demande a été envoyée avec succès.',
    successPageText:
      'Merci pour votre intérêt pour nos produits. Un de nos responsables vous contactera dans les plus brefs délais pour vous fournir toutes les informations nécessaires. <br>À bientôt.',
    failurePageTitle: 'Nous sommes désolés',
    failurePageText:
      "Une erreur s'est produite lors de l'envoi du formulaire. Veuillez réessayer plus tard.",
  },
  contatti: {
    apiPostinId: '00323384-4c7d-44b1-be33-f52aec27d0af',
  },
  careers: {
    apiPostinId: 'c4d492f2-93b6-449e-85cb-f3f3f6bc76bb',
    formCTA: 'Envoyer la candidature',
    formSubtitle: '<strong>Exigences et compétences</strong>',
    formCaption:
      'Si vous pensez être la personne qu’il nous faut, remplissez le formulaire et envoyez votre candidature.',
    otherPositionsTitle: 'Autres postes ouverts',
    postinApiId: 'e2209090-6264-4d73-803b-dd85af69e909',
  },
  seoSuccess: {
    title: 'Demande envoyée',
  },
  seoFailure: {
    title: 'Erreur !',
  },
}
